import { useSyncExternalStore } from "react";

// Is the browser online? (TODO §14.8.)
//
// `navigator.onLine` is a hint, not a guarantee — it says the machine has a network
// interface with a route, not that anything answers on it. That is exactly the right
// resolution for the one thing this is used for: deciding whether to *explain* a missing
// token as "you are offline". Nothing is gated on it; the gates are the token and the
// entitlement window (§14.6).
//
// It is a hook rather than a bare read because the answer changes without a render: a
// component that reads `navigator.onLine` directly keeps showing whatever was true when it
// last happened to re-render, which is how you get an offline banner that never appears.

function subscribe(onChange: () => void): () => void {
  window.addEventListener("online", onChange);
  window.addEventListener("offline", onChange);
  return () => {
    window.removeEventListener("online", onChange);
    window.removeEventListener("offline", onChange);
  };
}

function snapshot(): boolean {
  return typeof navigator === "undefined" ? true : navigator.onLine;
}

export function useOnline(): boolean {
  // Server snapshot is `true`: "assume connected" is the neutral answer, and it keeps the
  // offline wording from ever rendering into markup that was never offline.
  return useSyncExternalStore(subscribe, snapshot, () => true);
}
